import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(2, 'l_contact', {
	en: 'contact',
	de: 'kontakt'
});

export const match = (param) => matchParam(param, localizedParam);
